import { useRef } from 'react';
import { useIsomorphicEffect } from './useIsomorphicEffect';
export function useForwardedRef(ref) {
    const innerRef = useRef(null);
    useIsomorphicEffect(() => {
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(innerRef.current);
        }
        else {
            ref.current = innerRef.current;
        }
    });
    return innerRef;
}
//# sourceMappingURL=useForwardedRef.js.map